/* 20191031 : LGEUS-12462 add */
$(document).ready(function() {
	if(!document.querySelector('.C0083')) return false;
	$(window).on('resize',function(){
		if($(window).width() > 500){
			$(".C0083 .error-msg").before($(".C0083 .emailAddrBtn"));
		}else{
			$(".C0083 .error-msg").after($(".C0083 .emailAddrBtn"));
		}
	});
	$(".C0083 .emailAddr").on('keydown', function (e) {
		switch (e.keyCode) {
			case 13: // Enter
				e.preventDefault();
				$(".C0083 .emailAddrBtn").click();
				break;
			default:
				break;
		}
	});
	$(".C0083 .emailAddrBtn").on("click",function(e){
		e.preventDefault();
		if($(window).width() > 500){
			$(".C0083 .error-msg").before($(".C0083 .emailAddrBtn"));
		}else{
			$(".C0083 .error-msg").after($(".C0083 .emailAddrBtn"));
		}
		$(".C0083 .error-msg").css("display","none");

		var val = $(".C0083 .emailAddr").val().trim();
		var regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		var validBl = false;
		if(val !=null && val !=""){
			$(".C0083 .error-msg").find('.required').hide();
			if(!regex.test(val)) {
				$(".C0083 .error-msg").find('.invalid').show();
				validBl = true;
			}else{
				$(".C0083 .error-msg").find('.invalid').hide();
				validBl = false;
			}
		}else{
			$(".C0083 .error-msg").find('.invalid').hide();
			$(".C0083 .error-msg").find('.required').show();
			validBl = true;
		}
		if(!validBl){
			$(".C0083 .cmpid").val(document.location.href);
			$(".C0083 .emailAddr").val(xssfilter($(".C0083 .emailAddr").val()));
			$.ajax({
	            type: "POST",
	            enctype: 'multipart/form-data',
	            url: $(".C0083 form").attr("action"),
	            data: $(".C0083 form").serialize(),
	            timeout: 1200,
	            success: function (data) {
	            },
	            error: function (e) {
	            },
	            complete:function(f){
					$(".C0083 .beform").removeClass("active");
					$(".C0083 .afform").addClass("active");	
					dataLayer.push({"event": "userFormSubmission"}); // DC-908             	
	            }
       		 });
		} else{
			$(".C0083 .error-msg").css("display","block");
		}
	});

});
/* //20191031 : LGEUS-12462 add */